/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterplanfullname3m3Inputs */



/**
* | output |
* | --- |
* | "'Monster', 3 months" |
*
* @param {Monsterplanfullname3m3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterplanfullname3m3 = /** @type {((inputs?: Monsterplanfullname3m3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterplanfullname3m3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("'Monster', 3 months")
	if (locale === "es") return /** @type {LocalizedString} */ ("«Monster», 3 meses")
	return /** @type {LocalizedString} */ ("«Монстр», 3 месяца")
});
export { monsterplanfullname3m3 as "monsterPlanFullName3m" }